import React, {useMemo} from 'react';

import {createStyles, makeStyles, withStyles, WithStyles,} from '@material-ui/core/styles';


import locales from '../../../locales';
import {cardFieldType} from '../../../config/constants';
import ScheduleTable from '../../Common/ScheduleTable';
import {TRestaurant} from '../../../types/ICabinetStore';
import TitleNew from "../../Common/TitleNew";
import BlurChangeTextField from "../../Common/Fields/BlurChangeTextField";

const useStyles = makeStyles((theme) => createStyles({
  contentWrap: {
    padding: '0 20px 20px 20px',
    [theme.breakpoints.down(600)]: {
      paddingInline: 0
    },
    
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#0a192338',
      },
    },
  },
  address: {
    margin: '20px 0'
  }
}));

interface IProps {
  currentRestaurant: TRestaurant;
  updateRestaurant: (arg: {
    value: string | number, type: any
  }) => void;
}

const Index: React.FC<IProps> = ({
  currentRestaurant,
  updateRestaurant,
}) => {
  const classes = useStyles();

  const address = useMemo(() => {
    return `${currentRestaurant.address.country}, ${currentRestaurant.address.city}, ${currentRestaurant.address.street}, ${currentRestaurant.address.home}`
  }, [currentRestaurant])

  return (
    <div>
      <div className={classes.contentWrap}>
        <TitleNew text={locales.t('reservesSystem.basicInformation.title')} />
        <div>
          <span style={{color: 'rgba(10, 25, 35, 0.9)'}}>{locales.t('reservesSystem.basicInformation.name')}</span>
          <BlurChangeTextField
            fullWidth
            id="outlined-basic"
            variant="outlined"
            size='small'
            value={currentRestaurant.name}
            onChange={(value) => {
              updateRestaurant({
                value, type: cardFieldType.name
              })
            }}
          />
        </div>
        <div className={classes.address}>
          <BlurChangeTextField
            fullWidth
            id="outlined-basic"
            variant="outlined"
            size='small'
            label={locales.t('reservesSystem.basicInformation.address')}
            value={address}
            disabled
            onChange={() => {
            }}
          />
        </div>
        <ScheduleTable
          label={locales.t('reservesSystem.basicInformation.scheduleList')}
          type={'restaurant'}
        />
      </div>
    </div>
  )
};

export default Index;
